export {ResourceApiServiceProvider} from './resource-api-service-provider'
